// ░█▀▀▀ ░█▀▀█ ░█▀▀▀ ░█▀▀▀ 　 ▀▀█▀▀ ░█▀▀▀█ 　 ░█▀▀▀ ░█▀▀▄ ▀█▀ ▀▀█▀▀
// ░█▀▀▀ ░█▄▄▀ ░█▀▀▀ ░█▀▀▀ 　 ─░█── ░█──░█ 　 ░█▀▀▀ ░█─░█ ░█─ ─░█──
// ░█─── ░█─░█ ░█▄▄▄ ░█▄▄▄ 　 ─░█── ░█▄▄▄█ 　 ░█▄▄▄ ░█▄▄▀ ▄█▄ ─░█──
// The component is made to be edited. However, please edit the styling on .footer-custom.scss.

// ========================================================================================================================================
// Footer
// ========================================================================================================================================

import { Image, Link } from "components/anti"
import { sendDatalayerFooter } from "lib/function/datalayer"
import React from "react"

import { F_Q_STORE_INFO } from "lib/function"
import { useRouter } from "next/router"

export const Footer = () => {
  const router = useRouter()
  const { locale } = router
  const [storeInfo, setStoreInfo] = React.useState(null)

  React.useEffect(() => {
    const fetchStoreInfo = async () => {
      const response = await F_Q_STORE_INFO(
        { lang: locale },
        process.env.INIT_TOKEN
      )
      setStoreInfo(response?.data?.storeInfo)
    }
    fetchStoreInfo()
  }, [locale])
  const menuLinks = [
    { title: locale === "id" ? "Tentang" : "About", link: "/about" },
    { title: locale === "id" ? "Kontak Kami" : "Contact Us", link: "/contact" },
    { title: locale === "id" ? "Toko Kami" : "Our Store", link: "/our-store" },
    { title: locale === "id" ? "Bantuan" : "Help", link: "/help" },
  ]

  const socialMedia = [
    { title: "NAGAREY Facebook", link: "https://www.facebook.com/Nagarey/" },
    {
      title: "NAGAREY Instagram",
      link: "https://www.instagram.com/accounts/login/?next=/nagarey/",
    },
    {
      title: "NAGAREY TikTok",
      link: "https://www.tiktok.com/@nagarey.official",
    },
    {
      title: "NAGAREY YouTube",
      link: "https://www.youtube.com/channel/UCNdyL16Q8eOwY8GBdUMfcuQ",
      is_youtube: true,
    },
  ]

  // Update the contactLinks array to match the current contacts
  const contactLinks = [
    {
      type: "email",
      title: "hello@nagarey.com",
      link: "mailto:hello@nagarey.com",
      icon: <i className="icon-envelope mr-2"></i>,
    },
    {
      type: "phone",
      title: "+62-812-9906-9458",
      link: "https://api.whatsapp.com/send?phone=6281299069458",
      icon: <i className="aib ai-whatsapp mr-2"></i>,
      target: "_blank",
    },
  ]

  return (
    <footer className="sc-dark">
      {/* Footer Top */}
      <section className="footer-top">
        <div className="container">
          <Image
            src={"/img/logo/logo_footer.png"}
            className="pt-5 pb-4 logo-brand"
          />
        </div>
      </section>

      <section className="footer-main">
        <div className="container">
          <div className="row row-4 px-4">
            <div className="col-lg-3 col-footer order-lg-2 px-0">
              <div className="footer-menu">
                <div className="navbar-nav">
                  <div className="row">
                    {menuLinks.map((link, i) => {
                      return (
                        <div
                          key={i}
                          className="col-12"
                          onClick={() =>
                            sendDatalayerFooter(link.title, "menu")
                          }
                        >
                          <div className="nav-item" key={i}>
                            <Link className="nav-link" to={link.link}>
                              {link.title}
                            </Link>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-footer order-lg-1 px-0">
              <div className="footer-contact">
                <div className="footer-contact__item">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: storeInfo?.openingHours,
                    }}
                  />
                </div>
                {contactLinks.map((item, idx) => (
                  <div className="footer-contact__item" key={idx}>
                    <a
                      href={item.link}
                      title={item.title}
                      target={item.target}
                      rel={
                        item.target === "_blank"
                          ? "noopener noreferrer"
                          : undefined
                      }
                      onClick={() => sendDatalayerFooter(item.type, "contact")}
                    >
                      {item.icon}
                      {item.title}
                    </a>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-3 col-footer order-lg-3 px-0">
              <div className="footer-menu">
                <div className="navbar-nav">
                  <div className="row">
                    {socialMedia.map((link, i) => {
                      return (
                        <div
                          key={i}
                          className="col-12"
                          onClick={() =>
                            sendDatalayerFooter(
                              link.title.split("NAGAREY ")?.[1],
                              "social"
                            )
                          }
                        >
                          <div className="nav-item" key={i}>
                            <Link
                              className="nav-link social-link"
                              to={link.link}
                              target="_blank"
                            >
                              {link.title}
                            </Link>
                            {/* {link.is_youtube ? (
                              <NextLink className="nav-link" href={link.link}>
                                {link.title}
                              </NextLink>
                            ) :
                              <Link className="nav-link btn btn-link" to={link.link} target="_blank">
                                {link.title}
                              </Link>
                            } */}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-3 col-footer order-lg-4 px-0">
              <div className="footer-iframe-wrapper">
                <iframe
                  title="Newsletter Subscription Form"
                  // width="540"
                  height="450"
                  src="https://bf692fe5.sibforms.com/serve/MUIFAPjjFeGxluxYoRW5fhdcB7z2bV5x_77rvFp5MEx8hgtHKOZAHzfmfCTR-9Gvp5zqGF9j3KnfOuFxbTsiBBkQCKVhYd2Vn0emXRD1bH6taSXBXzAbN_EbCy0vPE9Z68LZRD_ZfECiQGWVbidSSsgqdSmVoHvn6-JWjVF89CwXa2-O5WyVFMK3TkZ6pr5WA6wjH-LdYBPuSapd"
                  loading="lazy"
                  scrolling="auto"
                  allowFullScreen
                />
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Footer Bottom */}
      <section className="footer-bottom">
        <div className="container">
          <div className="row w-100">
            <div className="col-md-6 col-left">
              ©{new Date().getFullYear()} Nagarey PT Trinaga Selaras Abadi. Site
              by{" "}
              <a
                href="https://www.antikode.com/"
                className="hover-underline"
                target="_blank"
              >
                Antikode
              </a>
              {/* . */}
            </div>

            {/* <div className="col-md-6 col-right">
              <Link to="/privacy-policy">
                {locale === "id" ? "Kebijakan Privasi" : "Privacy Policy"}
              </Link>
              <span className="divider">•</span>
              <Link to="/terms-conditions">
                {locale === "id" ? "Syarat & Ketentuan" : "Terms & Conditions"}
              </Link>
            </div> */}
          </div>
        </div>
      </section>
    </footer>
  )
}
